import { render } from "./MonitorsFormScreen.vue?vue&type=template&id=10d8d986"
import script from "./MonitorsFormScreen.vue?vue&type=script&lang=js"
export * from "./MonitorsFormScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__